import React, { useState, useEffect, useRef } from 'react';

const DatePicker = ({ value, onSelect, startDate, showToggle, isCurrent, onToggleCurrent, toggleLabel = "Currently work here" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [year, setYear] = useState(new Date().getFullYear());
    const wrapperRef = useRef(null);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const startYear = startDate && startDate !== 'Present' ? parseInt(startDate.split('/')[1], 10) : null;
    const startMonthIndex = startDate && startDate !== 'Present' ? parseInt(startDate.split('/')[0], 10) - 1 : -1;

    const handleSelect = (monthIndex) => {
        const monthNum = String(monthIndex + 1).padStart(2, '0');
        onSelect(`${monthNum}/${year}`);
        setIsOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [wrapperRef]);

    return (
        <div className="relative w-full" ref={wrapperRef}>
            <button type="button" onClick={() => setIsOpen(!isOpen)} className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-sm text-left text-white focus:outline-none focus:ring-2 focus:ring-cyan-500/60 focus:border-transparent">
                {value || <span className="text-neutral-500">Select date</span>}
            </button>
            {isOpen && (
                <div className="absolute z-10 top-full mt-2 w-64 bg-[#0b0e14]/95 backdrop-blur-md border border-white/10 rounded-lg p-4 shadow-lg">
                    <div className="flex justify-between items-center mb-4">
                        <button
                            type="button"
                            onClick={() => setYear(year - 1)}
                            className={`text-white font-bold text-lg px-2 ${startYear && year <= startYear ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={startYear && year <= startYear}
                        >
                            ‹
                        </button>
                        <span className="font-semibold">{year}</span>
                        <button
                            type="button"
                            onClick={() => setYear(year + 1)}
                            className={`text-white font-bold text-lg px-2 ${year >= currentYear ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={year >= currentYear}
                        >
                            ›
                        </button>
                    </div>
                    <div className="grid grid-cols-3 gap-2 text-center">
                        {months.map((month, index) => {
                            const isFutureMonth = year === currentYear && index > currentMonth;
                            const isBeforeStartDate = startYear !== null && (year < startYear || (year === startYear && index < startMonthIndex));
                            const isDisabled = isFutureMonth || isBeforeStartDate;
                            return (
                                <button
                                    key={month}
                                    type="button"
                                    onClick={() => handleSelect(index)}
                                    className={`p-2 rounded-md text-sm ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-cyan-500/15 hover:text-cyan-300'}`}
                                    disabled={isDisabled}
                                >
                                    {month}
                                </button>
                            );
                        })}
                    </div>
                    {showToggle && (
                        <div className="flex items-center justify-between mt-4 pt-4 border-t border-white/10">
                            <span className="text-sm">{toggleLabel}</span>
                            <button
                                type="button"
                                onClick={onToggleCurrent}
                                className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors ${isCurrent ? 'bg-cyan-500' : 'bg-neutral-700'}`}
                            >
                                <span className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${isCurrent ? 'translate-x-6' : 'translate-x-1'}`} />
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DatePicker;
